import { OldPlatformLegalStatement } from '#src/components/Cart/index.js';

import { formatScreenContent } from '../../helpers/format-screen-content.js';

import { hasTrial } from './helpers/has-trial.js';

export function MembershipDisclaimer({ membershipOrderItem, theme }) {
  if (!membershipOrderItem) return null;

  const content = formatScreenContent(membershipOrderItem?.screenContent || {});
  const membershipDisclaimer = hasTrial(
    membershipOrderItem?.selectedPaymentPlan?.subscription
  )
    ? content.braintreeDisclosureTrial
    : content.braintreeDisclosure;

  return !membershipDisclaimer ? null : (
    <OldPlatformLegalStatement
      membershipDisclaimer={membershipDisclaimer}
      theme={theme}
    />
  );
}
